<h1 mat-dialog-title>Enable user?</h1>
<mat-dialog-content>
  <p>{{ data.email }} will be able to sign in again.</p>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>Cancel</button>
  <button mat-flat-button color="primary" (click)="onConfirm()">Enable</button>
</mat-dialog-actions>
